import get from 'lodash/get'

import { fixJson } from '@/api/onboarding'

export const transformAIResponse = (fn, path) => {
  return async (data) => {
      const response = await fn(data)
      try {
        return JSON.parse(get(response, path))
      } catch (_) {
        const newData = {
          ujwt: data.ujwt,
          data: {
            promptId: '27b09033-0ca3-4fad-a2d5-322bad067367',
            OpenAiChatOptions: {
              Model: 'gpt-4o-mini',
              messages: [
                {
                  role: 'user',
                  content: get(response, path),
                },
              ],
            },
          },
        }
        const res = await fixJson(newData)
        const parsedJson = JSON.parse(
          get(res, 'OpenAiResponse.choices[0].message.content')
        )
        return parsedJson
      }
    }
}
